// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class ReportRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_REPORT_REQUEST_MESSAGE, fieldSet);
    }
    getTemplateName() {
        return this.getFieldValue(FieldsFactory.FIELD_TEMPLATE);
    }
    setTemplateName(name) {
        this.setFieldValue(FieldsFactory.FIELD_TEMPLATE, name);
    }
}
